import { BehaviorSubject } from 'rxjs';

const cartSubject = new BehaviorSubject({});

export const WebstoreDataService = {
  setCartInfo: (cartInfo: any, errorStatus: boolean) => cartSubject.next({ cartInfo, errorStatus }),
  getCartInfo: (): any => cartSubject.getValue(),
};
